import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import App from './App.tsx';
import { getStoredTheme } from './lib/theme-storage';
import './index.css';


// Apply initial theme from localStorage (will be overridden by user preferences after auth)
// This prevents flash of wrong theme while loading
const storedTheme = getStoredTheme();
if (storedTheme === 'dark') {
  document.documentElement.classList.add('dark');
} else if (storedTheme === 'light') {
  document.documentElement.classList.remove('dark');
} else {
  // No stored preference - default to dark while loading
  document.documentElement.classList.add('dark');
}


try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
} catch (err: any) {
  throw err;
}
